module.exports = __webpack_public_path__ + "img/t2-10.6603b054.svg";